export const planLimits = {
    designer: {
      Free: {
        totalInteractions: 10, // Total interaction limit for free plan
        weeklyInteractions: 3  // Weekly interaction limit for free plan
      },
      free: {
        totalInteractions: 10,
        weeklyInteractions: 3
      },
      Guest: {
        totalInteractions: 2, // Total interaction limit for guest plan
        weeklyInteractions: 2  // Weekly interaction limit for guest plan
      },
      guest: {
        totalInteractions: 2,
        weeklyInteractions: 2
      },
      my_project_plan: {
        totalInteractions: 15, // My Project plan: 15 total interactions
        weeklyInteractions: 5  // 5 interactions per week
      },
      standard_trial: {
        totalInteractions: 30,
        weeklyInteractions: 10
      },
      Standard: {
        totalInteractions: 30,
        weeklyInteractions: 10
      },
      standard_plan: {
        totalInteractions: 30,
        weeklyInteractions: 10
      },
      Pro: {
        totalInteractions: 50,
        weeklyInteractions: 15
      },
      pro_plan: {
        totalInteractions: 50,
        weeklyInteractions: 15
      },
      Admin: {
        totalInteractions: "Unlimited",
        weeklyInteractions: "Unlimited"
      },
    },
    facadeAIGenerations: {
      Free: 0,
      free: 0,
      Guest: 1,
      guest: 1,
      my_project_plan: 2,
      standard_trial: 2,
      Standard: 10,
      standard_plan: 10,
      Pro: 25,
      pro_plan: 25,
      Admin: "Unlimited",
      admin: "Unlimited",
    }
  };

  export default planLimits
